import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { CSVLink } from "react-csv";

import classNames from "classnames";

import { useTournamentRegistrationsContext } from "../contexts/TournamentRegistrations";
import useDownloadHandler from "../hooks/useDownloadHandler";
import { CSVData } from "../types/tournamentregistrations";

import Loading from "../../../../../components/Loading";
import { currencyFormat } from "../../../../../lib/utils";

const Totals = (): React.JSX.Element => {
    const { totals, orders } = useTournamentRegistrationsContext();
    const { handleDownload } = useDownloadHandler();
    const [csvData, setCSVData] = useState<Array<CSVData>>([]);

    const CSVHeaders = [
        { label: "Order Id", key: "orderId" },
        { label: "Order Date", key: "orderDate" },
        { label: "Order Status", key: "status" },
        { label: "Paid Date", key: "paidDate" },
        { label: "Tournament", key: "tournament" },
        { label: "User", key: "user" },
        { label: "Email", key: "email" },
        { label: "Team Name", key: "teamName" },
        { label: "Age Level", key: "ageLevel" },
        { label: "Friday Ok?", key: "fridayOk" },
        { label: "Amount", key: "amount" },
        { label: "Payment Type", key: "paymentType" },
        { label: "Order Notes", key: "orderNotes" },
    ];

    return (
        <Row className="mt-2" data-testid="registrationTotals">
            <Col className="totals" xs={6} lg={8}>
                <h4 data-testid="totalAmount">
                    Total: {currencyFormat.format(totals.total)}
                </h4>
                <h4 data-testid="unpaidAmount">
                    Unpaid: {currencyFormat.format(totals.unpaid)}
                </h4>
                <h4 data-testid="totalNumber">Number: {totals.count}</h4>
            </Col>
            <Col className="d-flex justify-content-end align-self-end">
                <Loading
                    className={classNames({
                        "align-content-center": true,
                        "mx-3": true,
                    })}
                    useContext={useTournamentRegistrationsContext}
                />
                <CSVLink
                    data-testid="exportButton"
                    data={csvData}
                    headers={CSVHeaders}
                    filename={`tournament-registrations.${new Date().getTime()}.csv`}
                    className={classNames({
                        btn: true,
                        "btn-primary": true,
                        disabled: orders.length === 0,
                    })}
                    target="_blank"
                    onClick={() => handleDownload(setCSVData)}
                    aria-disabled={orders.length === 0}
                >
                    Export Registration Data
                </CSVLink>
            </Col>
        </Row>
    );
};

export default Totals;
